module.exports = __webpack_public_path__ + "images/CC_Sortation Placeholder_Panel Media 4.png";